// @flow
import client from '../../client'
import { config } from '../../config'
import buildPrebookPriceUpdate from './builders/prebookPriceUpdate'
import { filterPriceQuery } from './utils'

// Types
import type { PriceUpdate } from '../../models/price'

export type Options = Object // FIXME

// API Endpoints
export const PRICE_RESERVATION_GET_ENDPOINT = '/pricing/reservation/'

/**
 * By given query returns price of the reservation
 * @type {Function}
 */
export const getReservationPrice = (data: Options): Promise<PriceUpdate> => {
  const query = filterPriceQuery(data)
  return client
    .post(PRICE_RESERVATION_GET_ENDPOINT, {
      body: query,
      baseUrl: config.BASE_URL_PRICING,
    })
    .then(buildPrebookPriceUpdate)
}

export default getReservationPrice
